import { render } from "./FixedButton.vue?vue&type=template&id=1672f305"
import script from "./FixedButton.vue?vue&type=script&lang=js"
export * from "./FixedButton.vue?vue&type=script&lang=js"

import "./FixedButton.vue?vue&type=style&index=0&id=1672f305&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__